export default __webpack_public_path__ + "static/media/SO.6b796c0b.svg";